import { InjectionToken, WritableSignal } from '@angular/core';

export const AIDA_CHARACTER_LIMIT: InjectionToken<WritableSignal<int>> = new InjectionToken('AIDA_CHARACTER_LIMIT');
